import SvgIcon from '../SvgIcon/SvgIcon';
import { SidebarModuleDTO } from '../../types/sidebar';

interface SidebarModuleHeaderProps {
  module: SidebarModuleDTO;

  open: boolean;
  onToggle: () => void;

  isActive?: boolean;

  // ✅ POS / Compact Sidebar
  compactMode?: boolean;
  sidebarExpanded?: boolean;
}

/**
 * 🧭 SidebarModuleHeader
 *
 * Encabezado expandible de módulo.
 *
 * UX:
 * ✅ Padre = contexto activo
 * ✅ Hijo = selección real
 * ✅ Compact mode compatible
 */
const SidebarModuleHeader: React.FC<SidebarModuleHeaderProps> = ({
  module,
  open,
  onToggle,
  isActive = false,
  sidebarExpanded = true,
}) => {
  // =====================================================
  // 🔒 Estado deshabilitado
  // =====================================================
  const isDisabled = module.disabled;

  // =====================================================
  // 🎨 Compact Sidebar
  // =====================================================
  const isCompactCollapsed = !sidebarExpanded;

  // =====================================================
  // 🎨 Render
  // =====================================================
  return (
    <div
      onClick={onToggle}
      title={isCompactCollapsed ? module.name : undefined}
      className={`
        group
        relative
        flex
        items-center
        rounded-md
        py-2.5
        font-medium
        transition-all
        duration-300
        ease-in-out

        ${
          isCompactCollapsed
            ? `
              justify-center
              px-2
            `
            : `
              gap-2.5
              px-4
            `
        }

        ${
          isDisabled
            ? `
              text-gray-400
              cursor-not-allowed
              opacity-60
            `
            : isActive
            ? `
              cursor-pointer
              bg-meta-4/40
              text-white
              shadow-sm
            `
            : `
              cursor-pointer
              text-bodydark1
              hover:bg-graydark
              hover:text-white
              dark:hover:bg-meta-4
            `
        }
      `}
    >
      {/* ===================================================== */}
      {/* 🔹 Icono */}
      {/* ===================================================== */}
      <SvgIcon
        name={module.icon}
        className={`
          shrink-0
          transition-colors
          duration-200

          ${isActive ? 'text-white' : 'text-bodydark1 group-hover:text-white'}
        `}
      />

      {/* ===================================================== */}
      {/* 🔹 Nombre */}
      {/* ===================================================== */}
      {!isCompactCollapsed && (
        <span className="flex-1 truncate">{module.name}</span>
      )}

      {/* ===================================================== */}
      {/* 🔹 Chevron */}
      {/* ===================================================== */}
      {!isCompactCollapsed && (
        <SvgIcon
          name="chevron-down"
          className={`
            absolute
            right-4
            top-1/2
            -translate-y-1/2
            transition-all
            duration-200

            ${
              open
                ? 'rotate-180 text-white'
                : 'text-bodydark1 group-hover:text-white'
            }
          `}
        />
      )}
    </div>
  );
};

export default SidebarModuleHeader;
